export default __webpack_public_path__ + "static/media/blog-img.24a41503.jpg";